import { render, staticRenderFns } from "./ClientActivities.vue?vue&type=template&id=d2658d4a&scoped=true&"
import script from "./ClientActivities.vue?vue&type=script&lang=js&"
export * from "./ClientActivities.vue?vue&type=script&lang=js&"
import style0 from "./ClientActivities.vue?vue&type=style&index=0&id=d2658d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2658d4a",
  null
  
)

export default component.exports